export default [
  { icon: 'calendar-week',  label: 'Week',  value: 'week' },
  { icon: 'calendar-month', label: 'Month', value: 'month' },
  { icon: 'calendar-year',  label: 'Year',  value: 'year' }
];
